import { useTranslation } from 'react-i18next';
import BoldBlue from './BoldBlue';
import styled from 'styled-components';

const AwardContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 2px 0;

    img {
        max-width: 13px;
        max-height: 13px;
        margin: 0;
    }
`;

const AwardsDisplay = (props) => {

    const { i18n } = useTranslation('common');

    if(!props.awards) return null;

    let decodedAwards = [];
    try {
        decodedAwards = JSON.parse(props.awards);
    } catch (error) {
        console.log(error);
        decodedAwards = [];
    }

    const removeAward = (index) => {
        decodedAwards.splice(index,1);
        props.setAwards(JSON.stringify(decodedAwards));
    }

    return (
        <>
            {decodedAwards && decodedAwards.length > 0 && <>
                <BoldBlue>{i18n.language === "fr" ? "Awards" : "Awards"}</BoldBlue><br/>
                {decodedAwards.map((award,i) => {
                    return (
                        <AwardContainer key={i}>
                            <span style={{display:"inline-block"}}>{award.title}, {award.year}</span>
                            {props.setAwards && <span style={{cursor:"pointer"}} onClick={() => removeAward(i)}><img src='/img/x_noir.png' alt='retirer' /></span>}
                        </AwardContainer>
                    )
                })}
            </>}
            {props.inputName && <input hidden name={props.inputName} readOnly value={props.awards} />}
        </>
    );
};

export default AwardsDisplay;
